/**
 * `rich_text` — a merchant-authored heading + body (module 22 D3).
 *
 * Plain text (spec 42 R8): stored as entered, rendered escaped, newlines kept
 * via `white-space: pre-wrap`. Class-free like every section here — inline CSS
 * custom properties only (see `index.ts`).
 */
export function RichText({
  heading,
  body,
  align,
}: {
  heading: string;
  body: string;
  align: "left" | "center";
}) {
  return (
    <section
      aria-label={heading}
      style={{
        maxWidth: "68ch",
        textAlign: align,
        ...(align === "center" ? { marginInline: "auto" } : {}),
      }}
    >
      <h2
        style={{
          fontFamily: "var(--font-display)",
          fontWeight: 500,
          fontSize: "1.5rem",
          color: "var(--ink)",
          margin: 0,
        }}
      >
        {heading}
      </h2>
      <p
        style={{
          marginTop: "0.75rem",
          fontSize: "0.9375rem",
          lineHeight: 1.6,
          color: "var(--ink-2)",
          whiteSpace: "pre-wrap",
        }}
      >
        {body}
      </p>
    </section>
  );
}
